export default __webpack_public_path__ + "static/media/joker.559f5499.svg";